"use client";

import routes from "@/app.route";
import { Button } from "@mui/material";
import Link from "next/link";

export default function DronePilotTraining() {
  return (
    <section className="pb-6 pt-6 md:pt-20 px-4">
      <div
        style={{
          backgroundColor: "#fff",
          backgroundImage: 'url("/images/home/drone-pilot-training.webp")',
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="max-w-7xl mx-auto py-6 md:py-8 rounded-lg md:rounded-2xl"
      >
        <div className="max-w-5xl mx-auto px-4">
          <h3 className="text-xl md:text-4xl font-bold text-center md:mb-6 mb-3">
            Drone Pilot Training by EVERSE
          </h3>
          <p className="text-center md:text-xl text-sm md:pb-96 pb-60">
            Become a certified drone pilot with EVERSE&apos;s DGCA-approved
            training program designed for beginners and professionals alike.
            Learn safe, legal and industry-ready drone operations through a
            perfect mix of theory, simulator training and hands-on flying
            experience.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-6">
        <div className="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-4 gap-6">
          {[
            {
              title: "5-Day Structured Training Program",
              image: "5-Day Structured Training Program.webp",
              url: "dgca-approved-drone-pilot-training-india",
            },
            {
              title: "DGCA-Approved Certification",
              image: "DGCA-Approved Certification.webp",
              url: "dgca-approved-drone-pilot-certification-guide",
            },
            {
              title: "Live Flying in Approved Zones",
              image: "Live Flying in Approved Zones.webp",
              url: "live-flying-authorized-zones-drone-pilot-training",
            },
            {
              title: "Expert DGCA-Authorised Instructors",
              image: "Expert DGCA-Authorised Instructors.webp",
              url: "expert-dgca-authorized-instructors-drone-pilot-training",
            },
          ].map((v, i) => (
            <Link
              key={i}
              href={routes.blog.url.replace(":slug", v.url)}
              style={{
                backgroundColor: "#fff",
                backgroundImage: `url("/images/home/${v.image}")`,
                backgroundPosition: "top",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
              className="relative px-6 pb-6 pt-60 block"
            >
              <div className="absolute bg-linear-to-b from-transparent to-black left-0 right-0 top-0 bottom-0"></div>
              <div className="text-white text-center font-bold md:text-lg text-base relative">
                {v.title}
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-6">
        <p className="text-center text-lg md:text-2xl">
          Whether you&apos;re a student, working professional or drone
          enthusiast this program equips you with the skills to fly confidently
          and professionally.
        </p>
        <div className="max-w-xl mx-auto px-4 py-3 bg-secondary/20 rounded-xl mt-6">
          <p className="text-center font-bold italic md:text-lg text-base">
            Start your drone journey today with EVERSE
          </p>
        </div>
        <div className="flex justify-center mt-6">
          <Button variant="contained" size="large" href={routes.contact.url}>
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
}
